import { render, staticRenderFns } from "./StoryTagSelector.vue?vue&type=template&id=19cdd8fb&scoped=true&"
import script from "./StoryTagSelector.vue?vue&type=script&lang=js&"
export * from "./StoryTagSelector.vue?vue&type=script&lang=js&"
import style0 from "./StoryTagSelector.vue?vue&type=style&index=0&id=19cdd8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdd8fb",
  null
  
)

export default component.exports